import ChatMessagesBlock from "./chat-messages-block";

export default ChatMessagesBlock;